import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ACCESS_REQUEST_NOTES_MAX, getRoleDescription, getUserRoleName, REQUESTABLE_ROLES, USER_ROLE } from '../../common/user';

export interface RequestDialogData {
    kind:'model'|'project'
    name:string
}

export interface AccessRequest {
    role:USER_ROLE
    notes:string
}

// asks for access to a model or project; closes with the request, or undefined when cancelled
@Component({
    selector: 'app-request-dialog',
    templateUrl: './request-dialog.html',
    styleUrls: ['./request-dialog.css'],
    standalone: false
})
export class RequestDialogComponent {
    notesControl = new FormControl('', {nonNullable:true, validators:Validators.maxLength(ACCESS_REQUEST_NOTES_MAX)})
    roleControl = new FormControl(USER_ROLE.READ, {nonNullable:true, validators:Validators.required})

    roles = REQUESTABLE_ROLES.map(role => ({role, name:getUserRoleName(role), description:getRoleDescription(role)}))
    ACCESS_REQUEST_NOTES_MAX = ACCESS_REQUEST_NOTES_MAX

    constructor(public dialogRef: MatDialogRef<RequestDialogComponent, AccessRequest>, @Inject(MAT_DIALOG_DATA) public data: RequestDialogData) {}

    isValid() {
        return this.roleControl.valid && this.notesControl.valid
    }

    onConfirm(): void {
        if (!this.isValid()) return
        this.dialogRef.close({role:this.roleControl.value, notes:this.notesControl.value.trim()});
    }
}
